import { FC } from 'react';

import { DialogConfirmDelete, LoadingLayout } from 'components';
import { useScrollToTop } from 'hooks';
import { usePageTitle } from 'libs/navigation';
import { ErrorFallback } from 'modules/App/ErrorFallback';

import { DialogChangeStatusFeature } from '../feature';
import { useOrder } from '../hooks/useOrder';
import { OrderProvider } from '../providers/OrderProvider';
import { OrderView } from '../views/OrderView';

export type OrderContainerProps = {};

export const OrderContainer: FC<OrderContainerProps> = () => {
  const {
    loading,
    order,
    title,
    breadcrumbsTitles,
    notFound,
    submitLoading,
    brokerTimezoneOffset,
    initialValues,
    isOpenDialogChangeStatus,
    disabledDates,
    minEndDate,
    directories,
    schemas,
    loadingDelete,
    isOpenDialogConfirmDelete,
    onCloseDialogChangeStatus,
    onSuccessChangeStatus,
    onSubmit,
    onEnableEdit,
    onDisableEdit,
    onChangeStatusEvent,
    onCloseDialogConfirmDelete,
    onOpenDialogConfirmDelete,
    onDelete,
    onDownloadOrder,
  } = useOrder();

  usePageTitle(title);

  useScrollToTop([]);

  if (notFound) {
    return <ErrorFallback />;
  }

  if (loading || !order) {
    return <LoadingLayout />;
  }

  return (
    <OrderProvider
      brokerTimezoneOffset={brokerTimezoneOffset}
      directories={directories}
      disabledDates={disabledDates}
      minEndDate={minEndDate}
      order={order}
      orderType={order.operationType}
      schemas={schemas}
      onChangeStatus={onChangeStatusEvent}
      onDelete={onOpenDialogConfirmDelete}
      onDisableEdit={onDisableEdit}
      onDownloadOrder={onDownloadOrder}
      onEnableEdit={onEnableEdit}
    >
      <OrderView
        breadcrumbsTitles={breadcrumbsTitles}
        initialValues={initialValues}
        submitLoading={submitLoading}
        title={title}
        onSubmit={onSubmit}
      />
      <DialogChangeStatusFeature
        isOpen={isOpenDialogChangeStatus}
        onClose={onCloseDialogChangeStatus}
        onSuccess={onSuccessChangeStatus}
      />
      <DialogConfirmDelete
        isOpen={isOpenDialogConfirmDelete}
        loading={loadingDelete}
        onClose={onCloseDialogConfirmDelete}
        onConfirm={onDelete}
      />
    </OrderProvider>
  );
};
